<template>
  <section class="index-tour">
    <transition name="partialloader">
      <div v-if="!context || !context_list.length > 0" class="pageloader partial">
        <span class="loading-text">{{loadingText}}</span>
      </div>
    </transition>

    <template v-if="context && context_list.length > 0">

      <div class="tabs no-scroll-x is-toggle is-fullwidth">
        <ul>
          <li data-v-step="1">
            <router-link to="/spots/"><span class="icon-spots"></span>{{ $t("spot_title_main") }}<span class="title-jp">{{ $t("spot_title_sub") }}</span></router-link>
          </li>
          <li class="is-active">
            <span><span class="icon-tours"></span>{{ $t("tour_title_main") }}<span class="title-jp">{{ $t("tour_title_sub") }}</span></span>
          </li>
        </ul>
      </div>
      <div class="filters">&nbsp;</div>
      <div class="grid">
        <div class="container">
          <div class="columns is-mobile is-multiline">
            <div v-for="tour in context_list" :key="tour.id" class="column is-12-mobile is-6-tablet is-6-desktop">
              <router-link :to="'/tours/' + tour.meta.slug" class="grid-item">
                <img :src="baseUrl + tour.thumb.url" :alt="tour.title">
                <h3 class="tour-title">{{tour.title}}</h3>
                <p v-if="tour.preview" class="tex-preview">
                  {{tour.preview_text}}
                </p>
                <div class="duration"><span class="icon-access_time"></span>{{ $t("time_title") }}{{tour.duration}}{{ $t("time_unit") }}</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </template>

  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
// import Grid from '../components/Grid.vue'
// import TextSizeSelector from '../components/TextSizeSelector.vue'
// import StreamField from '../components/StreamField.vue'

export default {
  components: {
    // Grid,
    // TextSizeSelector,
    // StreamField,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      type: 'tour.ToursIndexPage',
      slug: 'tours',
      loadingText: 'Loading',
      guide: {
        steps: [
          {
            target: '.icon-question-circle',
            content: 'guide_button',
            offset: -100,
            duration: 800,
          },
          {
            target: '.bm-burger-button',
            content: 'guide_menu',
            offset: -100,
            duration: 800,
          },
          {
            target: '.grid .column',
            content: 'guide_course',
            offset: -100,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
          {
            target: `[data-v-step='1']`,
            content: 'guide_spots',
            offset: -100,
            duration: 800,
            params: {
              placement: 'bottom',
            }
          },
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'getAllPages',
      'getSingleContext',
      'isPagesLoaded',
      'getAllTours',
      'isListLoaded',
    ]),
    context: function() {
      return this.getSingleContext(this.slug)
    },
    context_list: function() {
      return this.getAllTours.items
    },
  },
  methods: {
    ...mapActions([
      'fetchPageByPath',
      'fetchPageByType',
      'fetchTourList',
      'setGuideSteps',
    ]),
    someFunction: function() {
      
    },
  },
  created() {},
  beforeMount() {
    this.fetchPageByType({ type: this.type, slug: this.slug, lang:this.$root.$i18n.locale })
    this.fetchTourList({ lang:this.$root.$i18n.locale })
  },
  mounted() {this.setGuideSteps({ steps: this.guide.steps })}
}
</script>
